import config from '@/config/config.ts';

export type TAppTitle = {
  subtitle?: string | null,
  routeTitle?: string | null,
};

export function buildAppTitle(title: TAppTitle): string {
  // The order is especially important here.
  // Our goal here is to provide an distinguishable name early in the title.
  // This is important to allow customers to differentiate tabs faster.
  //
  // The assumption here is that customers have multiple tabs open (even within the context of the same asset)
  // but on different apps.
  const titles = [
    title.routeTitle,
    title.subtitle,
    `Qmulus (${config.VITE_APP_TENANT_NAME})`,
  ];
  return titles.filter(Boolean).join(' | ');
}
